import { gql } from "@apollo/client";
import Fragments from "./fragments";

export const CLONE_QUOTE = gql`
  mutation cloneQuote($quoteId: Int!) {
    cloneQuote(quoteId: $quoteId) {
      ...listQuoteItem
    }
  }
  ${Fragments.listQuoteItem}
`;

export const DELETE_QUOTE = gql`
  mutation deleteQuote($quoteId: Int!) {
    deleteQuote(quoteId: $quoteId)
  }
`;

export const CHANGE_RESPONSIBLE = gql`
  mutation changeResponsible($quoteId: Int!, $responsibleId: Int!) {
    changeResponsible(quoteId: $quoteId, responsibleId: $responsibleId)
  }
`;

export const SAVE_SCORING_QUESTIONS_WITH_ANSWERS = gql`
  mutation saveScoringQuestionsAnswers($input: ScoringQuestionsAnswersInput!) {
    saveScoringQuestionsAnswers(input: $input)
  }
`;

export const REQUEST_APPROVAL = gql`
  mutation requestApproval($quoteId: Int!, $indicative: Boolean!) {
    requestApproval(quoteId: $quoteId, indicative: $indicative)
  }
`;
